import { useCallback } from "react";
import type { CashierTradingAccount } from "@/api/cashier";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setSelectedAccount } from "@/redux/slices/accountSlice";

export const useAccount = () => {
  const dispatch = useAppDispatch();

  return {
    setSelectedAccount: useCallback(
      (account: CashierTradingAccount) => {
        dispatch(setSelectedAccount(account));
      },
      [dispatch]
    ),
    selectedAccount: useAppSelector((state) => state.account.selectedAccount),
  };
};
